import { useOrganisationsContext } from '@reapit-sales/api-v3'
import { OfficeSwitcherMenu } from '@reapit-sales/navigation'

/**
 * `useOfficeMenu` returns a mocked list of office menu items for use in the `OfficeSwitcher`.
 *
 * ### Returns:
 * An array of `OfficeSwitcherMenu` items, where each item includes:
 * - `id` (string): Unique identifier for the office.
 * - `officeName` (string): Display name of the office.
 *
 * ### Behavior:
 * 1. Returns a office menu for the dropdown.
 *
 * ### To Do:
 * Replace the hardcoded values with a call to an API service that retrieves office data.
 */
export const useOfficeMenu = (): OfficeSwitcherMenu => {
  const { organisations } = useOrganisationsContext()
  return organisations?.data || []
}
